import React from "react";

export default function Icons() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Icons</h2>
      <p>Route: /icons</p>
    </div>
  );
}
